import { createSyncAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';
import { TenantCustomFactoryFromJS, ITenantCustom } from '../entities/ITenantCustom';

export default function setTenantAction(data: ITenantCustom) {
	const action = createSyncAction(ActionTypes.SET_TENANT_ACTION, TenantCustomFactoryFromJS(data));
	return action;
}
